var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb"},[_c('el-breadcrumb',[_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.menu))]),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.page))]),(_vm.menu1)?_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.menu1))]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }